import { Link } from "@/lib/router-compat";
import { Check, X } from "lucide-react";
import { NO_COMMISSION_LINE } from "@/data/disclosuresCopy";
import { dgFeatureClick } from "@/lib/dataGraph";

const ROWS: { them: string; us: string }[] = [
  { them: "Paid when you pick their lender or agent", us: "Paid only by employers who offer us as a benefit" },
  { them: "Rankings can follow who pays the most", us: "We earn the same whatever you choose" },
  { them: "Your info may be sold as a lead", us: "Your details are shared only when you ask" },
];

/** Homepage comparison: how most homebuying sites are paid vs. Home Approach. */
export default function NoCommissionCompare() {
  return (
    <section aria-labelledby="no-commission" className="bg-background py-12 sm:py-14">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <h2 id="no-commission" className="text-center text-2xl font-bold text-foreground sm:text-3xl">
          {NO_COMMISSION_LINE}. Here's why that matters.
        </h2>
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <div className="rounded-2xl border border-border bg-muted/40 p-5">
            <p className="text-sm font-bold uppercase tracking-wide text-muted-foreground">Most homebuying sites</p>
            <ul className="mt-4 space-y-3">
              {ROWS.map((r) => (
                <li key={r.them} className="flex gap-2 text-sm text-muted-foreground">
                  <X className="mt-0.5 h-4 w-4 shrink-0" aria-hidden /> {r.them}
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-primary bg-card p-5">
            <p className="text-sm font-bold uppercase tracking-wide text-primary">Home Approach</p>
            <ul className="mt-4 space-y-3">
              {ROWS.map((r) => (
                <li key={r.us} className="flex gap-2 text-sm font-medium text-foreground">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden /> {r.us}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p className="mt-6 text-center text-sm">
          <Link
            to="/how-we-make-money"
            onClick={() => dgFeatureClick("home_no_commission", "how_we_make_money")}
            className="font-semibold text-primary hover:underline"
          >
            How we make money
          </Link>
        </p>
      </div>
    </section>
  );
}
